module.exports = __webpack_public_path__ + "static/sm-post_a-cad7abd6e20fd320ffa7130f4f2a03ad.png";